<template>
  <section class="location-section" :class="{ 'is-active': isActive }">
    <!-- CONTACT 타이틀 -->
    <h2 class="title-main" :class="{ show: isActive }">
      <span class="title-word" v-for="(letter, i) in 'CONTACT'.split('')" :key="'t'+i"
        :style="{ '--i': i }"
      >{{ letter }}</span>
    </h2>

    <!-- 관심고객 등록 폼 -->
    <div class="form-wrap" :class="{ show: isActive }">
      <p class="form-desc">용인남사 대우이안 플렉시티에 관심을 가져주셔서 감사합니다.<br/>아래 정보를 입력해주시면 상담원이 빠르게 연락드리겠습니다.</p>

      <form @submit.prevent="submit" class="register-form">
        <div class="form-group">
          <label>이름</label>
          <input type="text" v-model="form.name" placeholder="이름을 입력하세요" required />
        </div>
        <div class="form-group">
          <label>연락처</label>
          <div class="phone-inputs">
            <input type="tel" inputmode="numeric" ref="p1" v-model="form.p1" placeholder="010" maxlength="3" required @input="onPhone('p1', 3, 'p2')" />
            <span class="phone-dash">-</span>
            <input type="tel" inputmode="numeric" ref="p2" v-model="form.p2" placeholder="0000" maxlength="4" required @input="onPhone('p2', 4, 'p3')" />
            <span class="phone-dash">-</span>
            <input type="tel" inputmode="numeric" ref="p3" v-model="form.p3" placeholder="0000" maxlength="4" required @input="onPhone('p3', 4, null)" />
          </div>
        </div>
        <div class="form-group checkbox">
          <label class="checkbox-label">
            <input type="checkbox" v-model="form.agree" required />
            <span class="checkmark"></span>
            <span>개인정보 수집 및 이용에 동의합니다.</span>
          </label>
        </div>
        <button type="submit" class="submit-btn" :disabled="submitting">
          {{ submitting ? '등록 중...' : '상담 신청하기' }}
        </button>
      </form>
    </div>
  </section>
</template>

<script>
import { registerCustomer } from '@/firebase/customerService'

export default {
  name: 'LocationSection',
  props: {
    isActive: { type: Boolean, default: false }
  },
  data() {
    return {
      submitting: false,
      form: { name: '', p1: '010', p2: '', p3: '', agree: false }
    }
  },
  methods: {
    onPhone(field, maxLen, nextRef) {
      this.form[field] = this.form[field].replace(/[^0-9]/g, '')
      if (this.form[field].length >= maxLen && nextRef) {
        this.$refs[nextRef].focus()
      }
    },
    async submit() {
      if (!this.form.agree) {
        alert('개인정보 수집 및 이용에 동의해주세요.')
        return
      }
      this.submitting = true
      try {
        await registerCustomer({
          name: this.form.name,
          phone: `${this.form.p1}${this.form.p2}${this.form.p3}`
        })
        if (window.callDM) window.callDM('conversion')
        if (window.wcs) {
          if (!window.wcs_add) window.wcs_add = {}
          window.wcs_add['wa'] = 's_248a9401d7df'
          var _conv = {}
          _conv.type = 'lead'
          window.wcs.trans(_conv)
        }
        // Google Ads 전환 - 리드 양식 제출
        if (window.gtag) {
          window.gtag('event', 'conversion', {
            'send_to': 'AW-17708301937/M9zdCPWT-robEPH8_PtB',
            'value': 1.0,
            'currency': 'KRW'
          })
        }
        alert(`${this.form.name}님, 상담 신청이 완료되었습니다.\n빠른 시일 내에 연락드리겠습니다.`)
        this.form = { name: '', p1: '010', p2: '', p3: '', agree: false }
      } catch (error) {
        console.error('등록 오류:', error)
        alert('등록 중 오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.location-section {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 48px;
  text-align: center;
}

/* ===== CONTACT 타이틀 (letter-spacing 애니메이션) ===== */
.title-main {
  margin: 0;
  overflow: hidden;
  text-align: center;
  width: 100%;
  /* letter-spacing 끝 여백 보정 */
  text-indent: 14px;
}

.title-word {
  display: inline-block;
  font-family: var(--font-serif);
  font-size: clamp(48px, 5vw, 80px);
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: 60px;
  opacity: 0;
  transition: opacity 1.2s ease, letter-spacing 2.5s cubic-bezier(0.22, 1, 0.36, 1);
  transition-delay: 0.3s;
}

.title-main.show .title-word {
  opacity: 1;
  letter-spacing: 14px;
}

.title-word {
  font-size: clamp(56px, 6.5vw, 96px);
}

/* ===== 폼 래퍼 ===== */
.form-wrap {
  width: 100%;
  max-width: 620px;
  padding: 0 40px;
  margin: 0 auto;
  box-sizing: border-box;
  align-self: center;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.8s ease, transform 0.8s cubic-bezier(0.16, 1, 0.3, 1);
  transition-delay: 1.2s;
}

.register-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  margin: 0 auto;
}

.form-wrap.show {
  opacity: 1;
  transform: translateY(0);
}

.form-desc {
  font-family: var(--font-pretendard);
  font-size: 18px;
  font-weight: 400;
  color: #444;
  line-height: 1.75;
  text-align: center;
  margin: 0 0 44px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-group > label {
  font-family: var(--font-pretendard);
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: -0.2px;
  text-align: center;
}

.form-group input[type="text"],
.form-group input[type="tel"] {
  width: 100%;
  padding: 16px 18px;
  border: 1.5px solid #ddd;
  border-radius: 8px;
  background: #fff;
  font-family: var(--font-pretendard);
  font-size: 17px;
  font-weight: 500;
  color: #1a1a1a;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s ease;
}

.form-group input::placeholder {
  color: #aaa;
  font-weight: 400;
}

.form-group input[type="text"]:focus,
.form-group input[type="tel"]:focus {
  border-color: var(--ecofore-accent);
}

.phone-inputs {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.phone-dash {
  color: #bbb;
  font-weight: 300;
  font-size: 20px;
}

.phone-inputs input {
  flex: 1 1 0;
  min-width: 0;
  width: 100%;
  text-align: center;
}

.form-group.checkbox {
  align-items: center;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 15px;
  color: #444;
  font-weight: 500;
}

.checkbox-label input[type="checkbox"] {
  width: 20px;
  height: 20px;
  accent-color: var(--ecofore-accent);
}

.submit-btn {
  padding: 20px;
  background: var(--ecofore-primary);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-family: var(--font-pretendard);
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.2px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 16px;
  box-shadow: 0 4px 16px rgba(140, 199, 81, 0.25);
}

.submit-btn:hover:not(:disabled) {
  background: var(--ecofore-primary-dark);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(140, 199, 81, 0.35);
}

.submit-btn:hover:not(:disabled) {
  background: var(--ecofore-primary-dark);
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ===== 반응형 ===== */
@media (max-width: 1200px) {
  .title-word { letter-spacing: 30px; }
  .title-main.show .title-word { letter-spacing: 8px; }
}

/* ===== 태블릿 (max-width: 1024px) ===== */
@media (max-width: 1024px) {
  .location-section {
    gap: 36px;
    padding: 60px 0;
    height: auto;
    min-height: 100vh;
  }

  .title-word {
    font-size: clamp(36px, 4.5vw, 60px);
    letter-spacing: 24px;
  }

  .title-main.show .title-word {
    letter-spacing: 8px;
  }

  .form-wrap {
    padding: 0 32px;
  }
}

@media (max-width: 900px) {
  .title-word { letter-spacing: 20px; }
  .title-main.show .title-word { letter-spacing: 6px; }
}

/* ===== 모바일 (max-width: 768px) ===== */
@media (max-width: 768px) {
  .location-section {
    padding: 60px 20px;
    gap: 24px;
    height: auto;
    min-height: 100vh;
    overflow: visible;
    align-items: center;
    justify-content: center;
  }

  .title-main {
    text-indent: 5px;
  }

  .form-wrap {
    margin: 0 auto;
    align-self: center;
  }

  .register-form {
    align-items: stretch;
  }

  /* 모바일: 라벨 + 체크박스 왼쪽 정렬 */
  .form-group > label {
    text-align: left;
  }

  .form-group.checkbox {
    align-items: flex-start;
  }

  .checkbox-label {
    justify-content: flex-start;
  }

  .title-word {
    font-size: clamp(28px, 8vw, 40px);
    letter-spacing: 16px;
    transition: opacity 0.8s ease, letter-spacing 1.8s cubic-bezier(0.22, 1, 0.36, 1);
    transition-delay: 0.2s;
  }

  .title-main.show .title-word {
    letter-spacing: 5px;
  }

  .form-wrap {
    padding: 0 20px;
  }

  .form-desc {
    font-size: 13px;
    margin-bottom: 24px;
  }

  .register-form {
    gap: 14px;
  }
}

/* ===== 소형 모바일 (max-width: 480px) ===== */
@media (max-width: 480px) {
  .title-word {
    font-size: clamp(22px, 7vw, 30px);
    letter-spacing: 10px;
  }

  .title-main.show .title-word {
    letter-spacing: 3px;
  }

  .form-wrap {
    padding: 0 16px;
  }
}
</style>
